module.exports = __webpack_public_path__ + "media/images/icon__predict@2x-3e0da7bd9df84c8096506c14636ca050.png";